import React from 'react';
import startcase from 'lodash.startcase';

import Box from 'grommet/components/Box';
import Heading from 'grommet/components/Heading';
import FormField from 'grommet/components/FormField';
import Datepicker from 'elements/Datepicker';
import TextInput from 'elements/TextInput';
import Error from 'elements/Error';

export default function({
  season,
  value,
  name,
  onChange,
  onChangeDate,
  onFocusChange,
  state,
  prefix,
 }) {

  const title = prefix === 'mrtn'
    ? `${prefix.toUpperCase()} ${startcase(season)} applications`
    : `${startcase(prefix)} ${startcase(season)} applications`
  const datepickerLabel = season !== 'in_season'
    ? `Date majority of ${startcase(season)} commercial fertilizer was applied. Enter manure timing below.`
    : `Date majority of ${startcase(season)} commercial fertilizer was applied`
  return (
    <Box>
      <Heading tag="h3">{title}</Heading>
      <Error>{state.errors[name(season)]}</Error>
      <Datepicker
        season={season}
        label={datepickerLabel}
        error={state.errors[name(`application_date_${season}`)]}
        id={name(`application_date_${season}`)}
        value={value(`application_date_${season}`)}
        focused={state[`${name(`application_date_${season}`)}Focused`]}
        onDateChange={onChangeDate(name(`application_date_${season}`))}
        onFocusChange={onFocusChange(name(`application_date_${season}`))} />
      <Heading tag="h4" margin="small">Enter pounds or gallons of each <strong>product</strong> per acre applied.</Heading>
      <FormField label="MAP" error={state.errors[name(`${season}_MAP`)]}>
        <TextInput
          onChange={onChange}
          value={value(`${season}_MAP`)}
          name={name(`${season}_MAP`)}/>
      </FormField>
      <FormField label="DAP" error={state.errors[name(`${season}_DAP`)]}>
        <TextInput
          onChange={onChange}
          value={value(`${season}_DAP`)}
          name={name(`${season}_DAP`)}/>
      </FormField>
      <FormField display-if={season === 'spring'} label="Starter" error={state.errors[name(`${season}_starter`)]}>
        <TextInput
          onChange={onChange}
          value={value(`${season}_starter`)}
          name={name(`${season}_starter`)}/>
      </FormField>
      <FormField display-if={season === 'spring'} label="Starter Analysis" error={state.errors[name(`${season}_starter_analysis`)]}>
        <TextInput
          onChange={onChange}
          value={value(`${season}_starter_analysis`)}
          name={name(`${season}_starter_analysis`)}/>
      </FormField>
      <FormField label="NH3" error={state.errors[name(`${season}_NH3`)]}>
        <TextInput
          onChange={onChange}
          value={value(`${season}_NH3`)}
          name={name(`${season}_NH3`)}/>
      </FormField>
      <FormField label="Urea" error={state.errors[name(`${season}_urea`)]}>
        <TextInput
          onChange={onChange}
          value={value(`${season}_urea`)}
          name={name(`${season}_urea`)}/>
      </FormField>
      <Box direction="row" className="grommetux-form-field">
        <FormField label="UAN 28%" error={state.errors[name(`${season}_UAN28`)]}>
          <TextInput
            onChange={onChange}
            value={value(`${season}_UAN28`)}
            name={name(`${season}_UAN28`)}/>
        </FormField>
        <FormField label="UAN 32%" error={state.errors[name(`${season}_UAN32`)]}>
          <TextInput
            onChange={onChange}
            value={value(`${season}_UAN32`)}
            name={name(`${season}_UAN32`)} />
          </FormField>
        </Box>
    </Box>
  )
}



// WEBPACK FOOTER //
// ./src/components/Timings.js